<template>
  <div>
    <section class="section-green mt-0">
      <div class="container shop-header">
        <div class="row">
          <div class="col-sm-12 col-lg-6">
            <h1 class="heading2 uppercase text-uppercase text-white">
              Sklep Librus
            </h1>

            <p class="body1 text-white">
              Korzystaj z ekskluzywnych rabatów w Sklepie Librus! Zaloguj się na
              swoje Konto LIBRUS i wybierz usługę dopasowaną do Twoich potrzeb.
              Szybko, wygodnie, bezpiecznie.
            </p>
          </div>
          <div class="col-sm-12 col-lg-6" />
        </div>
      </div>
    </section>
    <section class="section-grey d-none d-lg-block pb-1">
      <div class="container shop-white-tile">
        <div class="row pl-3 pr-3 position-relative">
          <div class="shop-slogan-image" />
          <div class="col-3 aligned">
            <img
              src="../assets/images/foto/Devices_small.png"
              class="internal-image scale-12"
            />
          </div>
          <div class="col-6 p-5">
            <h3>Aplikacja mobilna</h3>
            <img
              src="../assets/images/Logo_librus_app_black.svg"
              class="internal-image w-50 mb-4"
              style="flex: 1"
            />
            <p class="font-paragraph--small">
              Skorzystaj z funkcji zwiększających komfort używania aplikacji
              Librus: wybierz Mobilne dodatki (MD), Mobilne dodatki PLUS (MD+)
              lub Rozszerzenie MD do MD+. Wiadomości, Zadania domowe,
              e-Usprawiedliwienia, a także Tygodniowy widok Planu lekcji i
              Terminarza, panel śledzenia postępów w nauce Moje Cele to tylko
              część udogodnień, z których możesz korzystać. Ciesz się wygodą na
              smartfonie, tablecie i komputerze.
            </p>

            <a
              href="/aplikacjamobilna"
              target="_blank"
              class="font-weight-bold link-lightblue"
              >Dowiedz się więcej</a
            >
          </div>
          <div class="col-3">
            <div class="h-75 text-center price-tag-box aligned">
              <div>
                <h1 class="price-tag mb-0">
                  <ShowPrice
                    :fetched-price="fetchedPrice"
                    :fetched-error="fetchedError"
                    :product-code="'mobilne-dodatki'"
                    prefix="od "
                  />
                </h1>
              </div>
            </div>
            <div class="col-12 p-0">
              <a
                href="https://portal.librus.pl/rodzina/sklep/mobilne-dodatki/wybor"
                target="_blank"
                class="btn btn-cta btn-block text-uppercase font-weight-bold"
              >
                Kup teraz
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="container shop-white-tile">
        <div class="row pl-3 pr-3 position-relative">
          <div class="col-3 aligned">
            <img
              src="../assets/images/akademia-mockup.png"
              class="internal-image scale-12"
            />
          </div>
          <div class="col-6 p-5">
            <img
              src="../assets/images/icons/ac-logo.svg"
              class="internal-image w-50 mb-4"
              style="flex: 1"
            />
            <p class="font-paragraph--small">
              Specjalistyczna platforma szkoleniowa, do której możesz uzyskać
              indywidualny dostęp już teraz za mniej niż 33 zł miesięcznie!
              Obszerna baza szkoleń pogrupowanych w ścieżki tematyczne,
              spotkania live (na żywo) lub Q&A (pytania i odpowiedzi) czy
              profesjonalne materiały do pobrania. Bez ograniczeń w korzystnej
              cenie.
            </p>

            <a
              href="https://akademia.librus.pl/oferta-indywidualna"
              target="_blank"
              class="font-weight-bold link-lightblue"
              >Dowiedz się więcej</a
            >
          </div>
          <div class="col-3">
            <div class="h-75 text-center price-tag-box aligned">
              <div>
                <h1 class="price-tag text-nowrap mb-0">389 zł</h1>
                <span class="text-white">Dostęp na 12 miesięcy</span>
              </div>
            </div>
            <div class="col-12 p-0">
              <a
                href="https://akademia.librus.pl/oferta-indywidualna"
                target="_blank"
                class="btn btn-cta btn-block text-uppercase font-weight-bold"
              >
                Kup teraz
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="container shop-white-tile">
        <div class="row pl-3 pr-3">
          <div class="col-3 aligned">
            <img
              src="../assets/images/foto/Brain.png"
              class="internal-image scale-12"
            />
          </div>
          <div class="col-6 p-5">
            <img
              src="../assets/images/Logo_indywidualni_black.svg"
              style="flex: 1"
              class="internal-image w-75 mb-4"
            />
            <p class="font-paragraph--small">
              Pakiet testów „Mocne strony i predyspozycje” oraz 3-letni dostęp
              do portalu z bazą metod, technik i kart pracy podnoszących
              efektywność nauki.
            </p>

            <a
              href="/indywidualni"
              target="_blank"
              class="font-weight-bold link-lightblue"
              >Dowiedz się więcej</a
            >
          </div>
          <div class="col-3">
            <div class="h-75 text-center price-tag-box">
              <div class="pt-4 aligned text-white">
                <div class="promotion-price-tag">
                  <span>Cena regularna</span>
                  <h3 class="ml-2 mb-0 d-inline-block text-white">
                    <s>39 zł</s>
                  </h3>
                </div>
              </div>
              <div>
                <h1 class="price-tag mt-4 mb-0">29 zł</h1>
                <span class="text-white">Konto LIBRUS</span>
              </div>
            </div>
            <div class="col-12 p-0">
              <a
                href="https://portal.librus.pl/rodzina/sklep/indywidualni"
                target="_blank"
                class="btn btn-cta btn-block text-uppercase font-weight-bold"
              >
                Kup teraz
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section-grey d-block d-lg-none pb-1">
      <div class="container shop-white-tile">
        <div class="row mb-3">
          <div class="col-sm-12 col-md-8 text-center pt-3">
            <h3>Aplikacja mobilna</h3>
            <img
              src="../assets/images/Logo_librus_app_black.svg"
              class="internal-image w-50 mb-4"
              style="flex: 1"
              alt="Logo Aplikacji Librus"
            />
          </div>
          <div class="price-tag-box aligned">
            <div class="text-white text-center">
              <h1 class="price-tag mb-0">
                <ShowPrice
                  :fetched-price="fetchedPrice"
                  :fetched-error="fetchedError"
                  :product-code="'mobilne-dodatki'"
                />
              </h1>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 aligned">
            <img
              src="../assets/images/foto/Devices_small.png"
              class="internal-image"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12 pl-5 pr-5">
            <p>
              Skorzystaj z funkcji zwiększających komfort używania aplikacji
              Librus: wybierz Mobilne dodatki (MD), Mobilne dodatki PLUS (MD+)
              lub Rozszerzenie MD do MD+. Wiadomości, Zadania domowe,
              e-Usprawiedliwienia, a także Tygodniowy widok Planu lekcji i
              Terminarza, panel śledzenia postępów w nauce Moje Cele to tylko
              część udogodnień, z których możesz korzystać. Ciesz się wygodą na
              smartfonie, tablecie i komputerze.
            </p>

            <a
              href="/aplikacjamobilna"
              target="_blank"
              class="font-weight-bold link-lightblue"
              >Dowiedz się więcej</a
            >
          </div>
        </div>
        <div class="row">
          <div class="col-12 my-3">
            <a
              href="https://portal.librus.pl/rodzina/sklep/mobilne-dodatki/wybor"
              target="_blank"
              class="btn btn-cta btn-block text-uppercase font-weight-bold"
            >
              Kup teraz
            </a>
          </div>
        </div>
      </div>
      <div class="container shop-white-tile">
        <div class="row mb-3">
          <div class="col-sm-12 col-md-8 text-center pt-3 pb-3 aligned">
            <img
              src="../assets/images/icons/ac-logo.svg"
              class="internal-image"
              style="flex: 1"
            />
          </div>
          <div class="price-tag-box aligned">
            <div class="text-white text-center">
              <h1 class="price-tag mb-0">389 zł</h1>
              <span class="text-white">Dostęp na 12 miesięcy</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 aligned">
            <img
              src="../assets/images/akademia-mockup.png"
              class="internal-image"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12 pl-5 pr-5">
            <p>
              Specjalistyczna platforma szkoleniowa, do której możesz uzyskać
              indywidualny dostęp już teraz za mniej niż 16 zł miesięcznie!
              Obszerna baza szkoleń pogrupowanych w ścieżki tematyczne,
              spotkania live (na żywo) lub Q&A (pytania i odpowiedzi) czy
              profesjonalne materiały do pobrania. Bez ograniczeń w korzystnej
              cenie.
            </p>

            <a
              href="https://akademia.librus.pl/oferta-indywidualna"
              target="_blank"
              class="font-weight-bold link-lightblue"
              >Dowiedz się więcej</a
            >
          </div>
        </div>
        <div class="row">
          <div class="col-12 my-3">
            <a
              href="https://akademia.librus.pl/oferta-indywidualna"
              target="_blank"
              class="btn btn-cta btn-block text-uppercase font-weight-bold"
            >
              Kup teraz
            </a>
          </div>
        </div>
      </div>
      <div class="container shop-white-tile">
        <div class="row mb-3">
          <div class="col-sm-12 col-md-8 text-center pt-3 pb-3 aligned">
            <img
              src="../assets/images/Logo_indywidualni_black.svg"
              class="internal-image"
              style="flex: 1"
            />
          </div>
          <div class="price-tag-box">
            <div class="pt-4 text-white">
              <div class="promotion-price-tag">
                <span>Cena regularna</span>
                <h3 class="ml-2 mb-0 d-inline-block text-nowrap text-white">
                  <s>39 zł</s>
                </h3>
              </div>
            </div>
            <div class="text-center">
              <h1 class="price-tag mt-4 mb-0">29 zł</h1>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 aligned">
            <img src="../assets/images/foto/Brain.png" class="internal-image" />
          </div>
        </div>
        <div class="row">
          <div class="col-12 pl-5 pr-5">
            <p>
              Pakiet testów „Mocne strony i predyspozycje” oraz 3-letni dostęp
              do portalu z bazą metod, technik i kart pracy podnoszących
              efektywność nauki.
            </p>

            <a
              href="/indywidualni"
              target="_blank"
              class="font-weight-bold link-lightblue"
              >Dowiedz się więcej</a
            >
          </div>
        </div>
        <div class="row">
          <div class="col-12 my-3">
            <a
              href="https://portal.librus.pl/rodzina/sklep/indywidualni"
              target="_blank"
              class="btn btn-cta btn-block text-uppercase font-weight-bold"
            >
              Kup teraz
            </a>
          </div>
        </div>
      </div>
    </section>
    <section class="section-grey d-block pt-0 shop-disclaimer">
      <div class="container">
        <div class="row">
          <div class="col-xs-12 pl-lg-0">
            <p class="disclaimer">
              * Ceny obowiązują od 1 września {{ currentYear }} r.
              <br />
              Ceny w sklepach z aplikacjami mobilnymi na poszczególnych
              platformach oraz sklepie na portalu Librus Rodzina mogą się
              różnić.
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import axios from "axios";
import appConfigStore from "../config/appConfigStore";
import ShowPrice from "../components/price/md-price.vue";
import getDynamicSchoolYear from "../assets/js/getDynamicSchoolYear";
export default {
  name: "SklepView",
  components: {
    ShowPrice,
  },
  async beforeRouteEnter(to, from, next) {
    try {
      const fetchedPrice = await axios.get(
        `${appConfigStore.config.PORTAL_API}/md-web-price`
      );
      next((vm) => vm.setData(false, fetchedPrice.data));
    } catch (e) {
      next((vm) => vm.setData(true, {}));
    }
  },
  data() {
    return {
      fetchedPrice: {},
      fetchedError: false,
      currentYear: getDynamicSchoolYear(true),
    };
  },
  created() {
    this.$emit("showFaqHeader", false);
  },
  mounted() {
    document.title = "Sklep";
  },
  methods: {
    setData(fetchedError, fetchedPrice) {
      this.fetchedError = fetchedError;
      this.fetchedPrice = fetchedPrice;
    },
  },
};
</script>
<style scope>
.price-prefix {
  display: inline-flex;
  align-items: flex-end;
  height: 72px;
}
.price-sufix {
  display: inline-flex;
  align-items: flex-start;
  height: 72px;
}
.price-prefix .text-white {
  margin-bottom: 8px;
}
.price-sufix .text-white {
  margin-top: 8px;
}
.one-line {
  display: flex;
}
.mr-6 {
  margin-right: 4rem;
}
@media screen and (max-width: 1135px) and (min-width: 990px) {
  .price-tag-box {
    flex-direction: column;
  }
  .price-prefix {
    width: 100%;
    height: auto;
    justify-content: center;
  }
  .price-tag {
    white-space: nowrap;
  }
}
@media screen and (max-width: 990px) {
  .price-prefix .text-white {
    padding-bottom: 8px;
  }
  .price-tag-box {
    align-content: center;
  }
}
@media screen and (max-width: 620px) {
  .price-tag-box {
    flex-wrap: wrap;
  }
  .price-prefix {
    width: 100%;
    height: auto;
    justify-content: center;
  }
  .one-line {
    align-items: flex-end;
  }
}
</style>
